export default "__VITE_ASSET__DKaCz7oB__"